// extracted by mini-css-extract-plugin
export default {"userVipCardsContainer":"UserVipCards_userVipCardsContainer__wffPt","header":"UserVipCards_header__G8C2F"};